export function getGlobalCssValue(name: string): string {
    if (typeof window === 'undefined') {
        return '';
    }
    return window
        .getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .replace(/\s*/g, '');
}

export const colorAlert = getGlobalCssValue('--color-alert');
export const colorBgLightest = getGlobalCssValue('--color-bg-1');
export const colorBgLight = getGlobalCssValue('--color-bg-2');
export const colorBgDark = getGlobalCssValue('--color-bg-3');
export const colorBgDarkest = getGlobalCssValue('--color-bg-4');
export const colorPrimary = getGlobalCssValue('--color-primary');
export const colorSecondary = getGlobalCssValue('--color-secondary');
export const colorSuccess = getGlobalCssValue('--color-success');
export const colorFolderItemIcon = getGlobalCssValue('--color-folder-item-icon');
export const colorGold = getGlobalCssValue('--color-gold');
export const colorText = getGlobalCssValue('--color-text');
export const colorTextFaded = getGlobalCssValue('--color-text-faded');
export const colorTextFaded20 = getGlobalCssValue('--color-text-faded-20');
export const colorTextOpposite = getGlobalCssValue('--color-text-opposite');

export const mobileThreshold = 768;
export const mobileHeightThreshold = 430;

export const panelWidth = Number.parseInt(getGlobalCssValue('--width-panel').replace('px', ''));
export const playlistHeight = Number.parseInt(
    getGlobalCssValue('--height-playlist').replace('px', '')
);

export const zIndexMenu = parseInt(getGlobalCssValue('--z-index-menu') || '100');

/* -------------------- */

export const DISPLAY = {
    LIST: 'list',
    MOSAIC: 'mosaic'
};

export enum DISPLAY_TYPE {
    LIST = 'list',
    MOSAIC = 'mosaic'
}
